import { ClientDTO } from "../DTO/clientDTO";
import { Address } from "./address";

export class Client{
    public id!: number;
    public name!: string;
    public externalId!: string;
    public customerId!: number;
    public addressList!: Address[];
    public deleted!: boolean;

    constructor(){
        this.addressList = new Array();
    }

    
    public static mapFromDTO(param:ClientDTO):Client{ 
        if (!param) throw new Error("parameter is null")
        let obj = new Client();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.externalId = param.externalId;
            obj.customerId = param.customerId;
            obj.addressList = param.addressList.map(dto=>Address.mapFromDTO(dto));
            obj.deleted = param.deleted;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:Client):ClientDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ClientDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.externalId = param.externalId;
            dto.customerId = param.customerId;
            dto.addressList = param.addressList.map(adr=>Address.mapToDTO(adr));
            dto.deleted = param.deleted;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public addAddress(address:Address){
        //currently we only support one address per customer. address.type=0
        this.addressList.push(address)
    }

    get address(){
        //currently we only support one address per customer. address.type=0
        return this.addressList?.length>0?this.addressList[0]:undefined;
    }
}